import { pinnedSearch } from 'ducks/entities/schema'

export const pinSearchGraphQlResponseSchema = {
  pinSearch: {
    pinned_search: pinnedSearch,
  },
}
